import { inject, observer } from 'mobx-react';
import React from 'react';
import { Alert, Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import ContentForState from '../../../loader/ContentForState';
import ErrorHandler from '../../../loader/ErrorHandler';
import CheckoutCustomerBenefits from '../CheckoutCustomerBenefits';
import CheckoutRegistrationButton from '../CheckoutRegistrationButton';

const CheckoutRegistration = ({ checkoutStore }) => {
  const { order, registrationMessages, modulesState } = checkoutStore;
  const { show_registration } = order;

  const renderRegistrationAlert = () =>
    registrationMessages?.map((message, index) => (
      <Alert
        key={index}
        className="CheckoutRegistration__registration-alert"
        color="danger"
      >
        <p>{message}</p>
      </Alert>
    ));

  return (
    <div className="CheckoutRegistration">
      <hr />
      <ContentForState
        state={modulesState.get('REGISTRATION')}
        loadingPlaceholder={[]}
        forError={() => {
          return registrationMessages?.length > 0 ? (
            renderRegistrationAlert()
          ) : (
            <ErrorHandler />
          );
        }}
        forLoaded={() => []}
      />
      <Row className="CheckoutRegistration__columns">
        <Col xs={12} md={6} className="CheckoutRegistration__prompt-column">
          {show_registration && (
            <>
              <p className="CheckoutRegistration__prompt-heading">
                <FormattedMessage
                  id="global.registerVisitorCustomerTitle"
                  defaultMessage="Would you like to register as a loyalty member at the same time?"
                />
              </p>
              <CheckoutRegistrationButton showLabel={false} />
            </>
          )}
        </Col>
        <Col xs={12} md={6} className="CheckoutRegistration__benefits-column">
          <CheckoutCustomerBenefits />
        </Col>
      </Row>
    </div>
  );
};

CheckoutRegistration.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
};

export default inject('checkoutStore')(observer(CheckoutRegistration));
